import { render, staticRenderFns } from "./role-dept-inspector-modal.vue?vue&type=template&id=4657d0e6&scoped=true"
import script from "./role-dept-inspector-modal.vue?vue&type=script&lang=js"
export * from "./role-dept-inspector-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4657d0e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4657d0e6')) {
      api.createRecord('4657d0e6', component.options)
    } else {
      api.reload('4657d0e6', component.options)
    }
    module.hot.accept("./role-dept-inspector-modal.vue?vue&type=template&id=4657d0e6&scoped=true", function () {
      api.rerender('4657d0e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/project-management/components/role-dept-inspector-modal.vue"
export default component.exports